import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';

export default class Sliders
{
    constructor ( sliderContainer )
    {


        this.sliderContainer       = sliderContainer;
        this.sliderContainerParent = this.sliderContainer.parentElement;
        this.swiperPagination      = this.sliderContainerParent.querySelector( '.swiper-pagination' );


        this.isBirthdaySlider = this.sliderContainer.classList.contains( 'birthdays-swiper' );

        Swiper.use( [ Navigation, Pagination ] );

        sliderContainer.classList.add( 'swiper' );

        this.prepareLazyImages();

        const numSlides = this.sliderContainer.querySelectorAll( '.swiper-slide' ).length;
        if ( numSlides < 2 )
        {
            // a one-slide slider won't be fun for anyone
            return;
        }

        this.setupSwiper()
    }


    setupSwiper ()
    {

        // console.log( 'Found swiper element', element );


        const swiperOptions = {
            // autoHeight: true,


            loop : true,


        }

        // not all sliders have bullets/pagination in this project


        if ( this.swiperPagination )
        {
            swiperOptions[ 'pagination' ] = {
                el   : '.swiper-pagination',
                type : 'bullets',
            };
        }


        if ( this.sliderContainer.classList.contains( 'keywords-swiper' ) )
        {

            const parentContainer = this.sliderContainer.closest( '.keywords-menu' );
            const prev            = parentContainer.querySelector( '.swiper-button-prev' );
            const next            = parentContainer.querySelector( '.swiper-button-next' );


            swiperOptions.navigation = {
                prevEl : prev,
                nextEl : next,
            };

            swiperOptions.loop          = false;
            swiperOptions.slidesPerView = 'auto';

        } else if ( this.sliderContainer.classList.contains( 'has-navigation' ) )
        {
            if ( typeof swiperOptions.navigation === 'undefined' )
            {
                swiperOptions.navigation = {};
            }

            this.btnNext = this.sliderContainerParent.querySelector( '.swiper-button-next' );
            this.btnPrev = this.sliderContainerParent.querySelector( '.swiper-button-prev' );

            console.log( 'BUTTONS', this.btnPrev, this.btnNext )

            swiperOptions.navigation.nextEl = this.btnNext;
            swiperOptions.navigation.prevEl = this.btnPrev;

            // swiperOptions.navigation.nextEl = '.swiper-button-next';
            // swiperOptions.navigation.prevEl = '.swiper-button-prev';


            this.maybeFindBtns();

            swiperOptions.on = {
                'init'   : this.adjustNavHeight,
                'update' : this.adjustNavHeight,
                'resize' : this.adjustNavHeight,
            };
        }


        if ( this.sliderContainer.classList.contains( 'no-loop' ) )
        {
            swiperOptions.loop = false;
        }


        if ( this.isBirthdaySlider )
        {

            swiperOptions.shortSwipes    = false;
            swiperOptions.allowTouchMove = false;
            swiperOptions.preventClicks  = false;
        }

        console.log( 'swiperOptions', swiperOptions )

        this.swiperInstance = new Swiper( this.sliderContainer, swiperOptions );
    }

    prepareLazyImages ()
    {
        const lazyImages = this.sliderContainer.querySelectorAll( 'img[data-src]' );

        if ( lazyImages.length < 1 )
        {
            return;
        }

        Array.from( lazyImages ).forEach( image =>
        {
            if ( !image.getAttribute( 'src' ) )
            {
                image.setAttribute( 'src', image.getAttribute( 'data-src' ) );
            }

            image.setAttribute( 'loading', 'lazy' );
            image.removeAttribute( 'data-src' );
            image.classList.remove( 'swiper-lazy' );

            const preloader = image.parentElement.querySelector( '.swiper-lazy-preloader' );

            if ( preloader )
            {
                preloader.remove();
            }
        } );
    }

    maybeFindBtns ()
    {
        const parent = this.sliderContainer.closest( '.block-slider' );

        if ( !parent )
        {
            return;
        }

        this.btnPrev = parent.querySelector( '.swiper-navigation .swiper-button-prev' );
        this.btnNext = parent.querySelector( '.swiper-navigation .swiper-button-next' );

    }

    adjustNavHeight ()
    {

        if ( !this.swiperInstance )
        {
            return;
        }

        const firstSlide      = this.swiperInstance.slides[ 0 ];
        const firstSlideImage = firstSlide.querySelector( '.image-container' );


        if ( !firstSlideImage )
        {
            return;
        }

        const slideHeight = firstSlideImage.getBoundingClientRect().height;


        this.btnPrev.style.top = Math.floor( slideHeight / 2 ) + "px";
        this.btnNext.style.top = Math.floor( slideHeight / 2 ) + "px";

    }
}

